import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AnnotationNavigationButton } from '../../../../modules/common/annotationNavigationButton/AnnotationNavigationButton';
import { ValidSaveIcon } from '../../../components/icons/ValidSaveIcon';
import { ProjectStatus } from '../../projects/projects.model';
import { IAnnotationService } from '../annotation.service';
import { IAnnotationsStore } from '../annotations.store';

interface IProps {
  onSubmit: () => Promise<void>;
  disabled: boolean;
}

export const SubmitAnnotationButtonContainer = observer((props: IProps): ReactElement => {
  const store = useInjection(IAnnotationsStore.$);
  const service = useInjection(IAnnotationService.$);

  const { t } = useTranslator();
  const { projectId } = useParams<{ projectId: string }>();

  useEffect(() => {
    const fetchProjectStatus = async (): Promise<void> => {
      await service.getProjectAnnotationInfoAsync(projectId);
    };

    void fetchProjectStatus();
  }, [projectId]);

  const isProjectDraft = store.projectStatus === ProjectStatus.Draft;

  return (
    <AnnotationNavigationButton
      size='md'
      id='submit-annotation'
      loaderKey='submit-annotation-button'
      disabled={props.disabled || isProjectDraft}
      onClick={props.onSubmit}
      title={t('submit_tooltip')}
      startDecorator={<ValidSaveIcon />}
    >
      {t('submit')}
    </AnnotationNavigationButton>
  );
});
